export const supportedLanguagesArray = ['en', 'hr', 'hu', 'sk'];
export type SupportedLanguage = (typeof supportedLanguagesArray)[number];

export type SupportedLanguageType = 'en' | 'hr' | 'hu' | 'sk';
